import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Grid, 
  Card,
  Paper,
  Typography,
  Divider
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

import { FormCud } from '../components/FormCud';
import { startAlerta } from '../../../../actions/ui/alertas';
import { FormDocumentacionCertificado } from '../components/FormDocumentacionCertificado';
import Buscador from '../../../../actions/ui/Buscador';
import { certificadoDiscaStartUpdate, certificadosLimpiar, fetchCertificados } from '../../../../actions/certificados';
import { TIPO_CERTIFICADOS } from '../../../../utils/constants';
import { BannerAfiliado } from '../../../afiliaciones/BannerAfiliado';
import { desSeleccionarAfiliado, seleccionAfiliado } from '../../../../actions/afiliado';
import { fetchSeccionales } from '../../../../actions/cbos/seccionales';
import { fetchCategorias } from '../../../../actions/cbos/categorias';
import { deleteDocumentacionAfiliadoIntegracion, getAllTiposDocumentacionAfiliadoIntegracion, getDocumentacionAfiliadoIntegracion, getFormularioCud, postFormularioCud, uploadArchivoAfiliadoIntegracionHandler } from '../../../../actions/discapacidad/discapacidadActions';
import { GenericDocumentacion } from '../../../atomic/organisms/GenericDocumentacion';

const useStyles = makeStyles((theme) => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: "column"
  },
  titleColor: {
    color: theme.palette.primary.main,
    textAlign: "center"
  },
  paper: {
    padding: "0",
    marginTop: "1em"
  },
  item: {
      padding: "1em"
  },
  textItem: {
      padding: "1em",
      textAlign: "center",
      color: "#333"
  }
}));

export const CargaCudLayout = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [afiliado, setAfiliado] = useState(null);
  const [show, setShow] = useState(false);

  const { formularioCud, tiposDocumentacionAbm, documentacionAfiliado } = useSelector((state) => state.discapacidad);
  const { items } = useSelector((state) => state.certificadosAfiliacion);

  const certificadoDiscapacidad = items.find(
    (item) => item?.tipoCertificado === TIPO_CERTIFICADOS.DISCAPACIDAD &&
      ((new Date(item?.fechaVencimiento) >= new Date() || item?.fechaVencimiento === "") ||
        (new Date(item?.fecha2doVencimiento) >= new Date())) &&
      (new Date(item?.fecha) <= new Date() || item?.fecha === "") &&
      !item.fechaBaja
  );

  const handleSaveCud = async (data) => {
    const tieneDiagnostico = data.diagnosticos.length > 0;
    // if(!tieneDiagnostico || data.documentacion?.length > 0){    
    if (tieneDiagnostico) {
      dispatch(postFormularioCud(data, formularioCud));
    } else {
      const msg = !tieneDiagnostico
        ? "Debe ingresar al menos un diagnostico"
        : "Debe ingresar al menos un documento"
      dispatch(startAlerta(
        msg,
        "error",
        "Error"
      ));
    }
  }

  const handleUpdateCertificado = async (data) => {
    dispatch(certificadoDiscaStartUpdate({ idItem: certificadoDiscapacidad.idItem, ...data }));
    /* const fechas = (
      (data.fechaVencimiento > data.fecha || (data.fecha2doVencimiento && data.fecha2doVencimiento > data.fecha) ||
      data.fechaActualizacion && data.fechaActualizacion > data.fecha)
    );  
    if(fechas || !certificadoDiscapacidad){    
      dispatch(certificadoDiscaStartUpdate({idItem: certificadoDiscapacidad.idItem, ...data}));
    }else{
      dispatch(startAlerta(
        data.fechaActualizacion
          ? "La fecha no puede ser superior a la fecha de actualización"
          : "La fecha no puede ser superior a la fecha de vencimiento",
        "error",
        "Error"
      ));
    } */
  }

  useEffect(() => {
    dispatch(fetchSeccionales());
    dispatch(fetchCategorias());
    dispatch(getAllTiposDocumentacionAfiliadoIntegracion());
  }, [dispatch])


  useEffect(() => {
    if (afiliado) {
      dispatch(fetchCertificados(afiliado?.id_afiliado, { setShow }));
      dispatch(getFormularioCud(afiliado?.id_afiliado, true));
      dispatch(getDocumentacionAfiliadoIntegracion(afiliado?.id_afiliado))
    }
  }, [dispatch, afiliado]);

  return (
    <Grid
      container
      spacing={1}
      justify="center"
      alignItems="center"
      style={{ marginTop: "1rem" }}
    >
      <Grid item md={4} />
      <Grid item xs={12} md={4}>
        <Grid
          container
          spacing={1}
          justify="center"
          alignItems="center"
          component={Card}
          style={{ padding: "0.5em 0" }}
        >
          <Grid item xs={12} className={classes.center} style={{ margin: "0.5em" }}>
            <Buscador
              value={afiliado}
              variant="outlined"
              setValue={(val) => {
                setShow(false);
                dispatch(certificadosLimpiar());
                setAfiliado(val);
                dispatch(desSeleccionarAfiliado());
                dispatch(seleccionAfiliado(val));
              }}
              label="Apellido y Nombre | Nro Doc | Nro Afiliado | CUIL"
              endpoint={(texto) => `Afiliados/traerPorNombreoDNIoNroAfi/${texto.replace("/", "__")}/Todos/Todos`}
              noOptionText={"No se encuentran afiliados"}
              filterOptions={options => (options.filter(option => option?.incapacitado === 1))}
              getOptionLabel={(option) => `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`}
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={
                      option.fecha_baja === null
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {`${option.apellido_y_nombre}`}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {" "}
                    {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                  </span>
                </div>
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={4} />
      {show &&
        <Grid item xs={12} md={9}>
          <Grid container spacing={2} justify="center" alignItems="center" style={{gap: "1em"}}>
            <Grid item xs={12} style={{ marginTop: "2em", padding: 0, display: "flex", justifyContent: "center" }}>
              <BannerAfiliado />
            </Grid>
            <Grid item component={Paper} elevation={5} xs={12}>
              <FormCud handleSubmit={(data) => handleSaveCud(data)} afiliado={afiliado} formularioCud={formularioCud} />
            </Grid>
            <Grid item xs={12} component={Paper} elevation={2}>
              <FormDocumentacionCertificado
                handleSubmit={(data) => handleUpdateCertificado(data)}
                certificadoDiscapacidad={certificadoDiscapacidad}
                afiliado={afiliado}
              />
            </Grid>
            <Grid item xs={12} component={Paper}>
              <Grid container spacing={1}>
                <Grid item xs={12} style={{display: "flex", justifyContent: "center"}} color="primary">
                    <Typography variant='button' style={{textAlign: "center"}}>Generalidades</Typography>
                </Grid>
                <Grid item xs={12} style={{marginBotton: "1em"}}>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{padding: "1em"}}>
                    <GenericDocumentacion
                      tiposDocumentacion={tiposDocumentacionAbm.map(item => ({...item.tipoDocumentacion}))}
                      documentacion={documentacionAfiliado.map(item => ({...item, idDocumentacion: item.idDocumentacionAfiliadoIntegracion }))}
                      deleteDocumentacion={(id) => {
                        dispatch(deleteDocumentacionAfiliadoIntegracion(afiliado.id_afiliado, id))
                      }}
                      handleFile={(file, idTipDoc) => {
                        dispatch(uploadArchivoAfiliadoIntegracionHandler(afiliado.id_afiliado, idTipDoc, file));
                      }}
                    />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </Grid>
  )
}
